import React, { useCallback, useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useFormContext, useWatch } from "react-hook-form";

import Dropdown from "components/atoms/Dropdown/Dropdown";
import { appendDefaultOption } from "helpers/commonHelpers";

interface NMFCFieldProps {
  isRequired: boolean;
  NMFCValues: any;
}

function NMFCField({ isRequired, NMFCValues }: NMFCFieldProps) {
  const intl = useIntl();
  const { getValues, control } = useFormContext();
  const watchedNmfcClass = useWatch({
    control,
    name: "nmfc_class",
  });

  const [NMFCOptions, setNMFCOptions] = useState<any>([]);

  useEffect(() => getNMFCOptions(), [watchedNmfcClass]);

  const getNMFCOptions = () => {
    if (NMFCValues) {
      const options = NMFCValues?.map((item: string[]) => ({
        label: item[0],
        is_active: false,
        value: item[0],
        desc: item[1],
      }));
      setNMFCOptions(options);
    }
  };

  const getNMFCClass = useCallback(
    () => NMFCOptions.filter((nmfc: any) => nmfc.value === getValues(`nmfc_class`)),
    [NMFCOptions],
  );
  return (
    <div>
      <div className="packing-list-add-item-input-large">
        <label className={isRequired ? "required" : ""}>
          <FormattedMessage id="new-request.packing-list.NMFC" defaultMessage="NMFC Class" />
        </label>
        <div>
          <Dropdown
            useHookForm
            name="nmfc_class"
            className="schedule-dropdown"
            defaultValue=""
            options={appendDefaultOption(NMFCOptions, intl)}
            required={isRequired}
          />
        </div>
        {getNMFCClass()[0]?.desc && (
          <div className="d-flex font-b3 mt-1 text-secondary text-wrap">{getNMFCClass()[0]?.desc}</div>
        )}
      </div>
    </div>
  );
}

export default NMFCField;
